"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuLabelsAssignButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const standard_button_1 = require("../buttons/standard-button");
exports.ActionMenuLabelsAssignButton = (0, styled_components_1.default)(standard_button_1.StandardButton) `
  display: block;
  min-width: 40px;
  margin: 50px 5px 0px 5px;
`;
//# sourceMappingURL=action-menu-labels-assign-button.js.map